import { render, staticRenderFns } from "./NotificationTagMenu.vue?vue&type=template&id=65156c9a&scoped=true&"
import script from "./NotificationTagMenu.vue?vue&type=script&lang=js&"
export * from "./NotificationTagMenu.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTagMenu.vue?vue&type=style&index=0&id=65156c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65156c9a",
  null
  
)

export default component.exports